<template>
  <dl class="form_item_container"
    :class="{'last_one': isLast}">
    <dt>{{title}}</dt>
    <dd><slot/></dd>
  </dl>
</template>

<script>
export default {
  name: 'FormItem',
  props: {
    title: {
      type: String,
      default: 'title'
    },
    isLast: Boolean
  },

  data() {
    return {

    };
  },
  components: {

  }
};
</script>

<style scoped lang="stylus">
@import '~@/assets/styles/var.styl';
.form_item_container {
  display flex
  min-height 64px
  font-size $fontSizeMiddle
  &.last_one {
    dd {
      border-bottom none
    }
  }
  dt {
    width 66px
    line-height 64px
    color $fontColorNormal
  }
  dd {
    flex 1
    border-bottom 1px solid $borderColor
  }
}
</style>
